import RewardsStoresShelf from './RewardsStoresShelf';

export default RewardsStoresShelf;
